import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonModule} from '../../../../../../modules/core/component/button/button.module';
import {FileUploadModule} from '../../../../file-upload/file-upload.module';
import {DocumentPdfFieldInputTypeHandlerComponent} from './document-pdf-field-input-type-handler.component';
import {
    DocumentSummaryModelFieldModule
} from '../../../../../../modules/document/common/api/component/document-summary-field/document-summary-field.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FileUploadModule,
        ButtonModule,
        DocumentSummaryModelFieldModule,
    ],
    declarations: [
        DocumentPdfFieldInputTypeHandlerComponent,
    ],
    exports: [
        DocumentPdfFieldInputTypeHandlerComponent,
    ],
})
export class DocumentPdfFieldInputTypeHandlerModule {}
